"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.quickOffer.name': 'Offerta Rapida',
    'tools.quickOffer.description': 'Raccoglie i campi del modulo offerta rapida dai messaggi degli utenti in base ai campi e opzioni configurati',
};
